var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master-consumable-item-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-be6c72a8!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master-consumable-item-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterConsumableItemList.vue
// module id = 649
// module chunks = 1